<template>
  <v-container grid-list-md>
    <v-layout row wrap align-center>
      <v-flex>
        <v-text-field
          v-model="filters.search"
          label="Buscar"
          prepend-inner-icon="mdi-magnify"
          solo
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex style="flex: 0 auto">
        <v-btn color="primary" append to="criar" large>Novo grupo</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="md2">
        <v-text-field v-model="filters.ano" label="Ano"></v-text-field>
      </v-flex>
      <v-flex class="md6">
        <v-select
          v-model="filters.idTurma"
          :items="turmas ? turmas : []"
          label="Turma"
          :item-text="turmas_format"
          item-value="id"
        ></v-select>
      </v-flex>
      <v-flex class="md3">
        <v-select
          v-model="filters.status"
          :items="situacao"
          label="Situação"
          item-text="nome"
          item-value="cod"
        ></v-select>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex class="md1 mt-3">
        <v-btn color="primary" @click="limpar">Limpar</v-btn>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex md12>
        <v-data-table
          :headers="headers"
          :items="mensagem.data"
          :search="filters.search"
          :options.sync="options"
          class="elevation-2"
          no-data-text="Não há mensagem disponíveis"
          no-results-text="Nenhum mensagem encontrado"
          :loading="table_load"
          :server-items-length="pagination.total"
          :footer-props="{ 'items-per-page-options': [5, 10, 20, 50] }"
        >
          <template #body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td
                  style="cursor: pointer"
                  @click="$router.push(`mensagens/${item.id}`)"
                >
                  <span class="mr-6">{{ item.nome }}</span>
                  <v-avatar
                    size="25"
                    color="primary"
                    v-show="item.mensagemNaoLida > 0"
                  >
                    <span class="white--text caption">{{
                      item.mensagemNaoLida
                    }}</span>
                  </v-avatar>
                </td>
                <td class="turma">
                  <v-chip
                    small
                    v-for="{ id, serie, nome } in item.turma"
                    :key="id"
                  >
                    {{ [serie.nome, nome, serie.nivel.nome].join(' ') }}
                  </v-chip>
                </td>
                <td>
                  {{ item.ano }}
                </td>
                <td>
                  <v-btn icon append :to="item.id" title="Mensagens do grupo">
                    <v-icon>mdi-chat-processing</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    append
                    :to="`${item.id}/editar`"
                    title="Editar grupo"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    append
                    @click="desativar(item.id)"
                    title="Desativar/Ativar grupo"
                  >
                    <template v-if="item.ativo === 'N'">
                      <v-icon left>mdi-eye</v-icon>
                    </template>
                    <template v-else>
                      <v-icon left>mdi-eye-off</v-icon>
                    </template>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <confirm ref="delete" :confirm-fn="remove"
          >Deseja excluir este mensagem?</confirm
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Mensagem, Turma } from '../../service'
import Confirm from '../../components/Confirm'
export default {
  components: { Confirm },
  data() {
    return {
      mensagem: [],
      items: [],
      headers: [
        {
          text: 'Grupo',
          value: 'nome'
        },
        {
          text: 'Turma',
          value: 'turma.nome',
          sortable: false
        },
        {
          text: 'Ano',
          value: 'ano'
        },
        { text: 'Ação', value: 'name', sortable: false }
      ],
      filters: {
        search: '',
        idTurma: null,
        ano: new Date().getFullYear()
      },
      situacao: [
        { cod: 'S', nome: 'Ativado' },
        { cod: 'N', nome: 'Desativado' }
      ],
      turmas: [],
      options: {},
      delay: 500,
      show_start_date: false,
      start_date: null,
      show_end_date: false,
      end_date: null,
      status: null,
      expand: false,
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      table_load: false,
      turmasLoaded: false,
      disciplinasLoaded: false,
      pagination: {
        current_page: 1,
        per_page: 0,
        total: 0
      },
      data_enable: false
    }
  },
  watch: {
    filters: {
      deep: true,
      /* eslint-disable */
      handler() {
        clearTimeout(this.delay)
        this.delay = setTimeout(() => this.load(), 750)
      },
    },
    options: {
      deep: true,
      handler() {
        clearTimeout(this.delay)
        this.delay = setTimeout(() => this.load(), 750)
      },
    },
  },
  async created() {
    this.turmas = await Turma.findAll({
      escola: this.escola,
      ano: this.filters.ano,
    })
    // this.disciplinasLoaded = this.disciplinas.length > 0
    this.turmasLoaded = this.turmas.length > 0
    this.load()
  },
  methods: {
    async load() {
      this.table_load = true
      if (this.turmasLoaded) {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        this.mensagem = await Mensagem.filter({
          ...this.filters,
          pagesize: this.options.itemsPerPage,
          page: this.options.page,
          order: this.options.sortBy ? this.options.sortBy[0] : '',
          dir: this.options.sortDesc == true ? 'DESC' : 'ASC',
          escola: this.escola,
        })
        this.pagination.total = this.mensagem.total
        this.pagination.current_page = this.mensagem.current_page
        this.pagination.per_page = parseInt(this.mensagem.per_page)
      }
      this.table_load = false
    },
    turmas_format(turma) {
      return `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
    },
    async remove(id) {
      await Mensagem.delete(id, { escola: this.escola })
      this.load()
    },
    limpar() {
      this.filters = {}
    },
    async desativar(grupo) {
      this.mensagem = await Mensagem.desativar(grupo, this.escola)
      await this.load()
    },
  },
}
</script>

<style scoped>
</style>
